class ProductType {
  constructor(value) {
    this.value = value
  }

  toLowerCase() {
    return this.value.toLowerCase()
  }

  toString() {
    return this.value
  }
}

class ProductTypeGroup {
  constructor(types) {
    // Convertir cada tipo en una instancia de ProductType
    this._types = types.map((type) => new ProductType(type))

    // Asignar cada tipo como una propiedad del objeto
    for (const type of types) {
      this[type] = new ProductType(type)
    }
  }

  // Método para obtener el grupo como array
  toArray() {
    return this._types.map((productType) => productType.toString())
  }

  // Método para verificar si un tipo pertenece a este grupo
  includes(productType) {
    if (!productType) return false
    return this._types.some(t => t.toString() === productType)
  }
}

// Definir los grupos de tipos
const ProductTypes = {
  BATHROOM: new ProductTypeGroup([
    'BASIN', // Lavabos
    'VANITY', // Lavabos
    'SINK', // Fregaderos
    'STRAY', // Platos de ducha
  ]),
  FLOORING_AND_CLADDING: new ProductTypeGroup([
    'TILE', // Soleria y aplacado
  ]),
  FLOORING_AND_CLADDING_DERIVATED: new ProductTypeGroup([
    'CLAD', // Aplacado o revestimiento
    'FLOOR', // Soleria
    'CLAD_FLOOR' // Soleria y aplacado/revestimiento. Tipo propio.
  ]),
  SLAB: new ProductTypeGroup([
    'SLAB', // Tabla
  ]),
  COVERING: new ProductTypeGroup([
    'ELAB', // Elaborado
    'PAN', // Paneles
    'PANEL RANURADO', // Panel ranurado
  ]),
  PROFESSIONAL: new ProductTypeGroup([
    'ACC', // Accesorios k&b
    'C_M', // Mantenimiento y limpieza
    'TOOL', // Herramientas
    'AD', // Adhesivos
    'SIL', // Siliconas
    'T&R', // Tratamiento y Reparaciones
  ]),

  // Método estático para verificar si es un producto estándar
  isStandardProduct(productType) {
    if (!productType) return false

    const normalizedType = String(productType).toUpperCase()

    return this.BATHROOM.includes(normalizedType) || this.FLOORING_AND_CLADDING.includes(normalizedType) || this.FLOORING_AND_CLADDING_DERIVATED.includes(normalizedType)
  },

   getStandardTypes() {
    return [
      ...this.FLOORING_AND_CLADDING.toArray(),
      ...this.FLOORING_AND_CLADDING_DERIVATED.toArray()
    ]
  }
}

export default ProductTypes